import React, { useState, useEffect } from 'react';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import ColorWrapper from '@styles/colors';
import BaseFrame from './baseFrame';

import { getTimezone, updateCompanyProfileValue } from '@reducers/membership';

const BaseModal = (props) => {
  const { user, getTimezone, updateCompanyProfileValue } = props;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selected, setSelected] = useState(user?.userInfo?.companyProfile?.factoryTimeZone);

  useEffect(() => {
    (async () => {
      const d = await getTimezone();
      if (d) {
        setData(d.map((i) => ({ name: i.name, value: i.id })));
      }
      setLoading(false);
    })();
  }, []);

  const onSelect = (item) => {
    setSelected(item.value);
  };

  const onCancel = () => {};

  const onSubmit = async () => {
    setSubmitLoading(true);
    await updateCompanyProfileValue({ factoryTimeZone: selected });
    setSubmitLoading(false);
  };

  return (
    <BaseFrame
      {...{
        loading,
        submitLoading,
        data,
        onCancel,
        onSelect,
        onSubmit,
        header: 'Time Zone',
        selected,
        ...props,
      }}
    />
  );
};

export default connect(({ user }) => ({ user }), { getTimezone, updateCompanyProfileValue })(ColorWrapper(BaseModal));
